import { Box, Button, TextField, Typography } from '@mui/material';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getReport } from 'store/actions';
import { selectMetadata, selectToken } from 'store/selectors';

import { buttonStyle } from './ReportGenerator.style';

const ReportGenerator = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const md = useSelector(selectMetadata);

  const [year, setYear] = React.useState('');

  React.useEffect(() => {
    if (md.year) {
      setYear(md.year);
    }
  }, [md.year]);

  const generateReport = () => {
    dispatch(getReport(year, token));
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      <Typography variant="h5">Generate Annual Report</Typography>
      <Typography variant="subtitle2" color="text.secondary">
        Last generated: {md.last_report_generation ?? 'N/A'}
      </Typography>
      <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
        <TextField
          value={year}
          onChange={(event) => setYear(event.target.value)}
          margin="dense"
          id="year"
          size="small"
          label="Year"
        />
        <Button variant="contained" sx={buttonStyle} onClick={generateReport}>
          Generate {year} Report
        </Button>
      </Box>
    </Box>
  );
};

export default ReportGenerator;
